export type BuildVersionPayload = {
  humanVersion: string;
  commitSha: string;
  builtAt: string;
  environment: string;
};

export async function fetchBuildVersion(apiUrl: string): Promise<BuildVersionPayload> {
  const response = await fetch(`${apiUrl}/api/version`, {
    credentials: "omit",
    cache: "no-store",
  });
  if (!response.ok) throw new Error(`Version API responded with ${response.status}`);

  const payload: unknown = await response.json();
  if (!payload || typeof payload !== "object") throw new Error("Version API returned an invalid payload");

  const data = payload as Partial<BuildVersionPayload>;
  if (
    typeof data.humanVersion !== "string" ||
    !data.humanVersion ||
    typeof data.commitSha !== "string" ||
    !/^[0-9a-f]{40}$/i.test(data.commitSha) ||
    typeof data.builtAt !== "string" ||
    typeof data.environment !== "string"
  ) {
    throw new Error("Version API returned incomplete build metadata");
  }

  return data as BuildVersionPayload;
}
